import { render, staticRenderFns } from "./DockRow.vue?vue&type=template&id=691d2b58&"
import script from "./DockRow.vue?vue&type=script&lang=js&"
export * from "./DockRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports